// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_jr-7";
export var emphasizeQuantity = "_jr-3";
export var flatBottomCorners = "_jr-5";
export var productImage = "_jr-0";
export var quantityContainer = "_jr-2";
export var quantityHeader = "_jr-6";
export var tooltip = "_jr-1";
export var wrapAndEllipsesOverflow = "_jr-4";